"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogDescription = exports.StyledDialogText = exports.StyledDialogTitle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const typographyReset_1 = require("../../../DesignSystem/styles/typographyReset");
const Dialog_1 = require("../../designTokens/Dialog");
// Copyright © Veeam Software Group GmbH
exports.StyledDialogTitle = styled_components_1.default.h3 `
    ${typographyReset_1.typographyReset};
    font-size: ${Dialog_1.dialogTokens.dialogDescriptionTitleFontSize.getVar()};
    font-weight: ${Dialog_1.dialogTokens.dialogDescriptionTitleFontWeight.getVar()};
    line-height: ${Dialog_1.dialogTokens.dialogDescriptionTitleLineHeight.getVar()};
    color: ${Dialog_1.dialogTokens.dialogDescriptionTitleColor.getVar()};
`;
exports.StyledDialogText = styled_components_1.default.p `
    ${typographyReset_1.typographyReset};
    font-size: ${Dialog_1.dialogTokens.dialogDescriptionTextFontSize.getVar()};
    font-weight: ${Dialog_1.dialogTokens.dialogDescriptionTextFontWeight.getVar()};
    line-height: ${Dialog_1.dialogTokens.dialogDescriptionTextLineHeight.getVar()};
    color: ${Dialog_1.dialogTokens.dialogDescriptionTextColor.getVar()};
`;
exports.StyledDialogDescription = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    padding: ${Dialog_1.dialogTokens.dialogDescriptionPaddingVertical.getVar()}
        ${Dialog_1.dialogTokens.dialogPaddingHorizontal.getVar()};
    word-break: break-word;

    ${({ hasBottomBorder }) => hasBottomBorder &&
    (0, styled_components_1.css) `
            border-bottom: ${Dialog_1.dialogTokens.dialogDescriptionBorderWidth.getVar()} solid
                ${Dialog_1.dialogTokens.dialogDescriptionBorderColor.getVar()};
        `}

    ${exports.StyledDialogTitle} + ${exports.StyledDialogText} {
        margin-top: ${Dialog_1.dialogTokens.dialogDescriptionIndent.getVar()};
    }
`;
//# sourceMappingURL=DialogDescription.styles.js.map